import Middleware from './middleware';
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime'; // Active schemes

import { CookieScheme } from '~auth/runtime';
Middleware.auth = authMiddleware;
export default function (ctx, inject) {
  // Options
  var options = {
    "resetOnError": false,
    "ignoreExceptions": false,
    "scopeKey": "scope",
    "rewriteRedirects": true,
    "fullPathRedirect": false,
    "watchLoggedIn": true,
    "redirect": {
      "login": "/login",
      "logout": "/",
      "home": "/",
      "callback": "/login"
    },
    "vuex": {
      "namespace": "auth"
    },
    "cookie": {
      "prefix": "auth.",
      "options": {
        "path": "/",
        "domain": ".gradlinc.co.za"
      }
    },
    "localStorage": {
      "prefix": "auth."
    },
    "defaultStrategy": "laravelSanctum"
  }; // Create a new Auth instance

  var $auth = new Auth(ctx, options); // Register strategies
  // laravelSanctum

  $auth.registerStrategy('laravelSanctum', new CookieScheme($auth, {
    "url": "https://api.gradlinc.co.za",
    "name": "laravelSanctum",
    "cookie": {
      "name": "XSRF-TOKEN"
    },
    "endpoints": {
      "csrf": {
        "withCredentials": true,
        "headers": {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        "url": "https://api.gradlinc.co.za/sanctum/csrf-cookie"
      },
      "login": {
        "withCredentials": true,
        "headers": {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        "url": "https://api.gradlinc.co.za/login"
      },
      "logout": {
        "withCredentials": true,
        "headers": {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        "url": "https://api.gradlinc.co.za/logout"
      },
      "user": {
        "withCredentials": true,
        "headers": {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        "url": "https://api.gradlinc.co.za/api/user"
      }
    },
    "user": {
      "property": false
    }
  })); // Inject it to nuxt context as $auth

  inject('auth', $auth);
  ctx.$auth = $auth; // Initialize auth

  return $auth.init().catch(function (error) {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return;
      }

      console.error('[ERROR] [AUTH]', error);
    }
  });
}